import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectVsics } from '../../../../common/category/store/slice'
import { Table } from '../../../../common/table'
import { getSchema, sortByParentId } from '../helper'
import { initCollapse, selectSegmentIndustry } from '../store/slice'
import { TBodyCustom } from './TBodyCustom'

const DynamicIndustry = () => {
  const dispatch = useDispatch()

  const vsicData = useSelector(selectVsics)
  const rawData = useSelector(selectSegmentIndustry)

  const treeData = useMemo(() => {
    return sortByParentId(vsicData)
  }, [vsicData])

  const ids = rawData.length ? treeData.map((item) => item.id) : []
  const schema = getSchema(false, true)

  useEffect(() => {
    dispatch(initCollapse(vsicData))
  }, [vsicData])

  return (
    <Table
      ids={ids}
      isDynamicReport={true}
      schema={schema}
      isDisplayScroll={false}
      isNoStickyHead={true}
      renderTBody={() => {
        return <TBodyCustom isDynamic={true} ids={ids} schema={schema} />
      }}
    />
  )
}

export default DynamicIndustry
